import React from "react";
import glamorous, { Svg } from "glamorous";
import { css } from "glamor";
import { textColor } from "../../style/index";
import ButtonRound from "../blocks/ButtonRound";
import { Link } from "react-router";

const Card = glamorous.div({
  height: 258,
  width: 230,
  ":hover": {
    cursor: "pointer"
  }
});

const ButtonContainer = glamorous.div({
  position: "relative"
});

const buttonStyle = selected => {
  const shadow = selected
    ? {
        boxShadow:
          "inset 0 2px 4px 1px rgba(0, 0, 0, 0.3), 0 4px 8px 1px rgba(102,80,160,0.3)"
      }
    : null;
  return css(
    {
      position: "absolute",
      top: "18px",
      right: "-8px"
    },
    shadow
  );
};

const Avatar = glamorous.div(
  {
    height: 172,
    background: "black",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8
  },
  ({ imageUrl }) => ({
    backgroundImage: `url(${imageUrl})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover"
  })
);

const UserDetails = glamorous.div({
  background: "white",
  borderBottomLeftRadius: 8,
  borderBottomRightRadius: 8,
  height: 50,
  padding: "18px 20px"
});

const Username = glamorous.span({
  fontFamily: "Hind, sans-serif",
  fontSize: 18,
  margin: 0,
  ...textColor.PURPLE
});

const Title = glamorous.div({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between"
});

const Age = glamorous.span({
  fontFamily: "Hind, sans-serif",
  fontSize: 14,
  ...textColor.PURPLE
});

const Pin = glamorous.span({
  paddingRight: 6
});

const Location = glamorous.div({
  fontFamily: "Hind, sans-serif",
  fontSize: 14,
  display: "flex",
  ...textColor.LIGHT_GRAY
});

const LocationText = glamorous.div({
  maxWidth: 174,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
});

const locationPin = (
  <Svg
    width="9px"
    height="14px"
    viewBox="0 0 9 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    position="relative"
    top={2}
    paddingRight={6}
  >
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Block-3"
        transform="translate(-24.000000, -261.000000)"
        fill="#999999"
        fillRule="nonzero"
      >
        <g id="Block">
          <g id="ico-location-pin" transform="translate(24.000000, 261.000000)">
            <path d="M4.50276203,0 C5.74047731,0 6.86998592,0.496391759 7.67974871,1.29700303 C8.49471062,2.09761431 9,3.20212587 9,4.42315383 C9,5.6595045 8.19023721,7.148999 7.48380691,8.45142882 C7.26706864,8.84662689 7.0607286,9.22682148 6.89598151,9.56615553 L4.82770697,13.7971371 C4.73997184,13.9746251 4.52355851,14.0506002 4.34288912,13.96441 C4.26555223,13.9289762 4.20868686,13.8680046 4.17261797,13.7971371 L2.10434343,9.56615553 C1.9392714,9.22682148 1.73293136,8.84662689 1.52139221,8.45142882 C0.80976279,7.14931822 0,5.6595045 0,4.42315383 C0,3.20212587 0.505289382,2.09729508 1.32025129,1.29700303 C2.13553814,0.496391759 3.25984764,0 4.50276203,0 Z M5.54453551,3.39493656 C5.27645593,3.13157759 4.91024299,2.96941231 4.50276203,2.96941231 C4.09008196,2.96941231 3.72386901,3.13157759 3.45578944,3.39493656 C3.18770986,3.65829554 3.02263783,4.01805985 3.02263783,4.42347306 C3.02263783,4.82377869 3.18770986,5.18354301 3.45578944,5.44690198 C3.72386901,5.71026096 4.09008196,5.87242624 4.50276203,5.87242624 C4.91024299,5.87242624 5.27645593,5.71026096 5.54453551,5.44690198 C5.81261508,5.18354301 5.97768711,4.82377869 5.97768711,4.42347306 C5.97801206,4.01805985 5.81294003,3.65829554 5.54453551,3.39493656 Z" />
          </g>
        </g>
      </g>
    </g>
  </Svg>
);

const starIcon = (
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Btn-/-Fav-Up"
        transform="translate(-19.000000, -7.000000)"
        fill="#8F6EE7"
      >
        <g id="Icon/Star-O">
          <g transform="translate(19.000000, 7.000000)">
            <path d="M6.26860718,6 L8.24817412,0.525 C8.39778712,0.225 8.69701311,0 8.9962391,0 C9.29546509,0 9.59469108,0.225 9.66949757,0.525 L11.6490645,6 L17.2249538,6 C17.5241798,6 17.8234058,6.225 17.9730188,6.525 C18.0478253,6.825 17.9730188,7.2 17.6737928,7.35 L13.3807916,10.5108278 L15.7288239,16.95 C15.8784369,17.25 15.7288239,17.625 15.5044044,17.775 C15.2799849,17.925 15.1303719,18 14.9807589,18 C14.8311459,18 14.6815329,17.925 14.5319199,17.85 L8.95883585,13.7292187 L3.38575178,17.85 C3.31094528,17.925 3.16133228,18 3.01171929,18 C2.86210629,18 2.7124933,17.925 2.5628803,17.85 C2.26365431,17.625 2.18884781,17.325 2.33846081,17.025 L4.65746224,10.575 L0.318685374,7.35 C0.0942658811,7.125 -0.0553471142,6.825 0.0194593835,6.525 C0.169072379,6.225 0.468298369,6 0.76752436,6 L6.26860718,6 L6.26860718,6 Z M7.40720576,7.14206839 C7.44477349,7.09080313 7.47624711,7.03480939 7.50010914,6.975 L8.9962391,2.925 L10.492369,6.975 C10.5671755,7.275 10.8664015,7.5 11.1656275,7.5 L11.3152405,7.5 L14.9807589,7.5 L12.1669427,9.54529369 C12.0648069,9.59460064 11.9753839,9.66664886 11.9037489,9.75295769 C11.677094,10.0051181 11.6374375,10.4557073 11.838886,10.725 C11.8421926,10.7299727 11.8455357,10.7348722 11.8489146,10.7396992 L13.4098225,15.15 L9.44507808,12.225 C9.31202402,12.1249513 9.13459701,12.0842196 8.95883585,12.0962109 C8.78307468,12.0842196 8.60564768,12.1249513 8.47259361,12.225 L4.50784924,15.15 L6.22839868,10.5 C6.37801168,10.2 6.30320518,9.9 6.00397919,9.675 L3.01171929,7.5 L6.75204417,7.5 C7.05233511,7.5 7.28565723,7.36571591 7.40720576,7.14206839 L7.40720576,7.14206839 Z" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

const starIconFilled = (
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Btn-/-Fav-Up-Down"
        transform="translate(-19.000000, -7.000000)"
        fill="#3C2E5F"
      >
        <g id="Btn-/-Fav-Dn">
          <g id="Icon/Star-F" transform="translate(19.000000, 7.000000)">
            <path d="M6.26860718,6 L8.24817412,0.525 C8.39778712,0.225 8.69701311,0 8.9962391,0 C9.29546509,0 9.59469108,0.225 9.66949757,0.525 L11.6490645,6 L17.2249538,6 C17.5241798,6 17.8234058,6.225 17.9730188,6.525 C18.0478253,6.825 17.9730188,7.2 17.6737928,7.35 L13.3807916,10.5108278 L15.7288239,16.95 C15.8784369,17.25 15.7288239,17.625 15.5044044,17.775 C15.2799849,17.925 15.1303719,18 14.9807589,18 C14.8311459,18 14.6815329,17.925 14.5319199,17.85 L8.95883585,13.7292187 L3.38575178,17.85 C3.31094528,17.925 3.16133228,18 3.01171929,18 C2.86210629,18 2.7124933,17.925 2.5628803,17.85 C2.26365431,17.625 2.18884781,17.325 2.33846081,17.025 L4.65746224,10.575 L0.318685374,7.35 C0.0942658811,7.125 -0.0553471142,6.825 0.0194593835,6.525 C0.169072379,6.225 0.468298369,6 0.76752436,6 L6.26860718,6 L6.26860718,6 Z" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

const UserCard = props => {
  const { account, avatar, city, region, age } = props.member;
  return (
    <Card>
      <ButtonContainer>
        <ButtonRound
          onClick={() => {
            props.favToggle(account.data.username, props.favKey);
          }}
          buttonType={"white"}
          height={35}
          width={62}
          otherStyles={buttonStyle(account.data.is_favorite)}
        >
          {account.data.is_favorite ? starIconFilled : starIcon}
        </ButtonRound>
      </ButtonContainer>
      <Link to={`/~${account.data.username}`}>
        <Avatar imageUrl={avatar.data.urls.profile} />
        <UserDetails>
          <Title>
            <Username>{account.data.username}</Username>
            <Age>{age}</Age>
          </Title>
          <Location>
            {locationPin}
            <LocationText>
              {city}, {region}
            </LocationText>
          </Location>
        </UserDetails>
      </Link>
    </Card>
  );
};

export default UserCard;



// WEBPACK FOOTER //
// ./src/components/common/UserCard.jsx